<!-- 購入済みチケットの価格表示 -->
<template>
  <div class="row total-price">
    <label class="name">料金</label>
    <div v-if="isVisiblePrice" class="value">
      <span>{{ totalPrice }}</span> {{ $t("common.unit") }}
    </div>
    <div v-else class="value">
      <span>******</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BgMyTicketPaymentAmount",
  props: {
    totalPrice: {
      type: Number,
      required: true,
    },
    isVisiblePrice: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  font-size: 14px;
}

.row label {
  width: 110px;
  color: #888888;
}

.row .value {
  width: calc(100% - 110px);
  font-weight: bold;
  color: black;
}

.row.total-price {
  align-items: flex-end;
}

.row.total-price .value span {
  font-size: 20px;
}
</style>
